import React from 'react';
import {h, Component} from 'preact'
import Message from "./../Message";

export default class MessagesList extends Component {
    render() {
        const { messages, sendMessage, cardWidth, getMessageImage } = this.props;
        const BodyTag = h ? 'base' : 'div';

        return (
            <BodyTag target="_blank">
                {
                    messages.map((message, i) => (
                        <Message
                            key={message.id}
                            cardWidth={cardWidth}
                            message={message}
                            allowButton={i === messages.length - 1}
                            image={getMessageImage(message)}
                            sendMessage={sendMessage}
                            showImage={true}
                        />
                    ))
                }
            </BodyTag>
        );
    }
}



// WEBPACK FOOTER //
// ./components/app/widget/MessagesList.js